import styled from "styled-components";

export default styled.div`

& {
  width: 100%;
  height: 100%;
  overflow:scroll;
  border: 1px solid ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.primary_light};
}
button{
  margin-top: 20px;
  margin-bottom: 20px;
}
.category {
  margin-left:20px;
}
main{
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.spacing_04};
  background-color: transparent;
  border:0px;
}



.imagePreview{
  width: 100%;
  max-width: 150px;
  min-width: 75px;  
}

`
